// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function ConfigurationItemReminderDialog(tabPage, parent) {
    var self = this;
    var _deleteMessageRefDocument = Bao.Session.GetMessage("msgDeleteConfigurationItemReminderReferenceDocument");
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogResult = ko.observable();
    self.DialogViewModel.TotalRows = ko.observable();
    self.DialogViewModel.PageIndex = ko.observable(0);
    self.DialogViewModel.PageSize = ko.observable(20);
    self.DialogViewModel.ReminderDocumentCollection = ko.observableArray();
    self.DialogViewModel.SelectedReminderReferenceDocumentRow = ko.observable();
    self.DialogViewModel.ReminderReferenceDocumentButtons = ko.observableArray();
    self.DialogViewModel.SortingReminderReferenceDocument = ko.observableArray();
    self.DialogViewModel.ReminderIntervalReadOnly = ko.observable(false);
    self.DialogViewModel.ToolbarButtons = ko.observableArray([]);
    self.DialogViewModel.ToolbarButtons.subscribe(function () {
        self.DialogViewModel.ToggleToolbarButtons();
    });
    self.DialogViewModel.SelectedReminderReferenceDocumentRow.subscribe(function () {
        self.DialogViewModel.ToggleToolbarButtons();
    });
    self.DialogViewModel.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemReminderReferenceDocumentCollection", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: parent.ConfigurationItem.ConfigurationItemId(),
            configurationItemReminderId: self.DialogViewModel.ConfigurationItemReminderId(),
            pageIndex: self.DialogViewModel.PageIndex(),
            pageSize: self.DialogViewModel.PageSize(),
            sorting: self.DialogViewModel.SortingReminderReferenceDocument()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.DialogViewModel.SelectedReminderReferenceDocumentRow(null);
            self.DialogViewModel.TotalRows(0);
            self.DialogViewModel.ReminderDocumentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.DialogViewModel.ReminderDocumentCollection(searchResult.Models);
                self.DialogViewModel.TotalRows(searchResult.TotalRows);
            }
        });
    };
    self.DialogViewModel.DownloadConfigurationItemReminderReferenceDocument = function (configurationItemReminderId, configurationItemReminderReferenceDocumentId) {
        window.open("ConfigurationItemTab/ReminderReferenceDocumentDownload?id=" + configurationItemReminderReferenceDocumentId);
    };
    self.DialogViewModel.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.DialogViewModel.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "ConfigurationItemReminderReferenceDocumentEdit":
                case "ConfigurationItemReminderReferenceDocumentRemove":
                case "ConfigurationItemReminderReferenceDocumentExport":
                    button.Enabled(!(self.DialogViewModel.SelectedReminderReferenceDocumentRow() == null));
                    break;
            }
        });
    };
    self.DialogViewModel.AddConfigurationItemReminderReferenceDocument = function (model, configurationItemReminderId) {
        tabPage.IsLoading(true);
        if (model.IsDocumentNew() == true) {
            self.DialogViewModel.DocumentCount(self.DialogViewModel.DocumentCount() + 1);
        }
        Bao.post("ConfigurationItemTab/AddConfigurationItemReminderReferenceDocument", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            reminderReferenceDocumentModel: ko.map.toJS(model),
            configurationItemReminderId: configurationItemReminderId
        }), function () {
            parent.ConfigurationItem.TabPage.DirtyFlag(true);
            self.DialogViewModel.RefreshGrid();
        });
    };
    self.DialogViewModel.DeleteConfigurationItemReminderReferenceDocument = function (configurationItemReminderId, configurationItemReminderReferenceDocumentId) {
        self.DialogViewModel.DocumentCount(self.DialogViewModel.DocumentCount() - 1);
        return Bao.post("ConfigurationItemTab/DeleteConfigurationItemReminderReferenceDocument", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            configurationItemReminderId: configurationItemReminderId,
            configurationItemReminderReferenceDocumentId: configurationItemReminderReferenceDocumentId
        }), function () {
            parent.ConfigurationItem.TabPage.DirtyFlag(true);
            self.DialogViewModel.RefreshGrid();
        });
    };
    self.DialogViewModel.EditConfigurationItemReminderReferenceDocument = function (configurationItemReminderId, configurationItemReminderReferenceDocumentId) {
        self.DialogViewModel.ShowConfigurationItemReminderReferenceDocumentDialog(parent.ConfigurationItem.ConfigurationItemId(), configurationItemReminderId, configurationItemReminderReferenceDocumentId);
    };
    self.DialogViewModel.ShowConfigurationItemReminderReferenceDocumentDialog = function (configurationItemId, configurationItemReminderId, configurationItemReminderReferenceDocumentId) {
        window.baorequire(["ViewModels/Dialogs/ConfigurationItemReminderReferenceDocumentDialog"], function (vm) {
            var dialog = new vm(tabPage, parent);
            dialog.Show(configurationItemId, configurationItemReminderId, configurationItemReminderReferenceDocumentId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.DialogViewModel.AddConfigurationItemReminderReferenceDocument(dialog.DialogViewModel, self.DialogViewModel.ConfigurationItemReminderId());
                }
            });
        });
    };
    var reminderTypeIdChanged = function (value) {
        if (value != null) {
            Bao.post("ConfigurationItemTab/GetReminderDefinition", JSON.stringify({
                reminderTypeId: value,
                configurationItemTypeId: parent.ConfigurationItem.ConfigurationItemTypeId(),
                countryId: parent.ConfigurationItem.CountryId(),
                stateId: parent.ConfigurationItem.StateId()
            }), function (newInterval) {
                if (self.DialogViewModel.ReminderInterval() == null || self.DialogViewModel.ReminderInterval() == 0) {
                    self.DialogViewModel.ReminderInterval(newInterval.ReminderInterval);
                    self.DialogViewModel.TimeUnitId(newInterval.TimeUnitId);
                    self.DialogViewModel.TimeUnitName(newInterval.TimeUnitName);
                }
                if (newInterval.IntervalFixed != null && newInterval.IntervalFixed == true) {
                    self.DialogViewModel.ReminderInterval(newInterval.ReminderInterval);
                    self.DialogViewModel.TimeUnitId(newInterval.TimeUnitId);
                    self.DialogViewModel.TimeUnitName(newInterval.TimeUnitName);
                    self.DialogViewModel.ReminderIntervalReadOnly(true);
                }
                else {
                    self.DialogViewModel.ReminderIntervalReadOnly(false);
                }
            });
        }
        else {
            self.DialogViewModel.ReminderIntervalReadOnly(false);
        }
    };
    self.DialogViewModel.toolbarDocumentClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemReminderReferenceDocumentAdd":
                self.DialogViewModel.ShowConfigurationItemReminderReferenceDocumentDialog(parent.ConfigurationItem.ConfigurationItemId(), self.DialogViewModel.ConfigurationItemReminderId(), null);
                break;
            case "ConfigurationItemReminderReferenceDocumentEdit":
                if (self.DialogViewModel.SelectedReminderReferenceDocumentRow() != null) {
                    self.DialogViewModel.ShowConfigurationItemReminderReferenceDocumentDialog(parent.ConfigurationItem.ConfigurationItemId(), self.DialogViewModel.ConfigurationItemReminderId(), self.DialogViewModel.SelectedReminderReferenceDocumentRow().OpenData);
                }
                break;
            case "ConfigurationItemReminderReferenceDocumentRemove":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageRefDocument, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DialogViewModel.DeleteConfigurationItemReminderReferenceDocument(self.DialogViewModel.ConfigurationItemReminderId(), self.DialogViewModel.SelectedReminderReferenceDocumentRow().OpenData);
                    }
                });
                break;
            case "ConfigurationItemReminderReferenceDocumentExport":
                if (self.DialogViewModel.SelectedReminderReferenceDocumentRow() != null) {
                    self.DialogViewModel.DownloadConfigurationItemReminderReferenceDocument(self.DialogViewModel.ConfigurationItemReminderId(), self.DialogViewModel.SelectedReminderReferenceDocumentRow().OpenData);
                }
                break;
        }
    };
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.ReminderTypeId() == null) {
            isComplete = false;
        }
        if (self.DialogViewModel.TargetDateJs() == null || self.DialogViewModel.TargetDateJs() == "") {
            isComplete = false;
        }
        if (self.DialogViewModel.IsComplete() == true) {
            if (self.DialogViewModel.CompleteDateJs() == null || self.DialogViewModel.CompleteDateJs() == "") {
                isComplete = false;
            }
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.DialogViewModel.ReminderTypeId = ko.observable();
    self.DialogViewModel.ReminderTypeId.subscribe(function (value) {
        reminderTypeIdChanged(self.DialogViewModel.ReminderTypeId());
    });
    self.Show = function (configurationItemId, configurationItemReminderId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemTab/ShowConfigurationItemReminderDialog", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItemReminderId: configurationItemReminderId
        }), function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel, ko.dirtyFlag());
            self.DialogViewModel.RefreshGrid();
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
}
export default ConfigurationItemReminderDialog;